var height_3 = $('#technology-section-3 .counter span').height();
var inView3 = false;

var child3_1 = height_3*2;
var child3_2 = height_3;
var child3_3 = 0;

$(document).ready(function() {
    aos();

    $('#technology-section-3 .counter span').each(function() {
        let orig = parseFloat($(this).text());
        $(this).html('');
        $(this).append(`<div class="orig">${orig}</div>`);

        for (let i = 0; i < 2; i++) {
            let random;
            if (orig % 1 !== 0) {
                let val1 = orig.toString().split(".")[0];
                let val2 = orig.toString().split(".")[1];

                random = randomNumber(val1) + '.' + randomNumber(val2);
            } 
            else {
                random = randomNumber(orig);
            }

            $(this).append(`<div class="random">${random}</div>`);
        }
    });

    $('#technology-section-3 .counter div:nth-child(1)').css('top', `${child3_1}px`);
    $('#technology-section-3 .counter div:nth-child(2)').css('top', `${child3_2}px`);
    $('#technology-section-3 .counter div:nth-child(3)').css('top', `${child3_3}px`);
});

$(window).scroll(function() {
    aos();

    $section3 = $('#technology-section-3 .counter-row');
    if (isElementInView($section3)) {
        if (!inView3) { 
            setTimeout(() => {
                $('#technology-section-3 .counter div:nth-child(1)').css('top', `${child3_1-height_3}px`);
                $('#technology-section-3 .counter div:nth-child(2)').css('top', `${child3_2-height_3}px`);
                $('#technology-section-3 .counter div:nth-child(3)').css('top', `${child3_3-height_3}px`);
            }, 200);
            setTimeout(() => {
                $('#technology-section-3 .counter div:nth-child(1)').css('top', `${child3_1-(height_3*2)}px`);
                $('#technology-section-3 .counter div:nth-child(2)').css('top', `${child3_2-(height_3*2)}px`);
                $('#technology-section-3 .counter div:nth-child(3)').css('top', `${child3_3-(height_3*2)}px`);
            }, 400);

            inView3 = true;
        }
    }
    else {
        if (inView3) {
            $('#technology-section-3 .counter div:nth-child(1)').css('top', `${child3_1}px`);
            $('#technology-section-3 .counter div:nth-child(2)').css('top', `${child3_2}px`);
            $('#technology-section-3 .counter div:nth-child(3)').css('top', `${child3_3}px`);

            inView3 = false;
        }
    }

    $bar_5 = $('#technology-section-5 .compare');
    if (visiblePercent($($bar_5)) > 10) {
        if (!$bar_5.find('.bar').hasClass('active')) {
            $bar_5.find('.bar').addClass('active');
        }
    }
    else {
        if ($bar_5.find('.bar').hasClass('active')) {
            $bar_5.find('.bar').removeClass('active');
        }
    }
});

function randomNumber(number) {
    let length = number.toString().length;
    let min = Math.pow(10, length - 1);
    let max = Math.pow(10, length) - 1;

    return Math.floor(Math.random() * (max - min + 1)) + min;
}

function aos() {
    $aos = $('.aos-init');
    $aos.each(function() {
        if (visiblePercent($(this)) > 10) {
            if (!$(this).hasClass('aos-animate')) {
                $(this).addClass('aos-animate');
            }
        }
        else {
            if ($(this).hasClass('aos-animate')) {
                $(this).removeClass('aos-animate');
            }
        }
    });
}